<template>
  <div class="user-container">
    <slot name="header"></slot>
    <div class="content">
      <section class="fill-container">
        <div class="input-container">
          <label for="Phone">
            <pre class="label need">手&nbsp;机&nbsp;号:</pre>
          </label>
          <el-input
            id="Phone"
            placeholder="请输入您的手机号"
            v-model="Phone"
            :disabled="!hasForget"
          />
        </div>
        <!-- <div class="input-container">
          <label for="ImageCode">
            <pre class="label need">图形验证:</pre>
          </label>
          <el-input id="ImageCode" placeholder="请输入图形验证码" />
        </div> -->
        <div class="input-container">
          <label for="MsgCode">
            <pre class="label need">短信验证:</pre>
          </label>
          <el-input
            id="MsgCode"
            placeholder="请输入短信验证码"
            v-model="MsgCode"
          />
          <button class="code-btn" @click="getCode">
            {{ msgCodeContent }}
          </button>
        </div>
        <template >
          <div class="input-container">
            <label for="Password">
              <pre class="label need">登录密码:</pre>
            </label>
            <el-input
              id="Password"
              placeholder="请输入您的登录密码"
              v-model="Password"
              show-password
            />
          </div>
          <div class="input-container">
            <label for="PsdConfirm">
              <pre class="label need">确认密码:</pre>
            </label>
            <el-input
              id="PsdConfirm"
              placeholder="请再次输入您的登录密码"
              v-model="PsdConfirm"
              show-password
            />
          </div>
        </template>
        <!-- <div class="input-container">
          <label for="HospitalCode">
            <pre class="label need">医院代码:</pre>
          </label>
          <el-input
            type="text"
            id="HospitalCode"
            placeholder="请输入医院代码"
            v-model="HospitalCode"
          />
        </div>
        <div class="input-container">
          <label for="PersonalProfile">
            <pre class="label need">个人简介:</pre>
          </label>
          <div class="textarea">
            <el-input
              class="textarea"
              type="textarea"
              id="PersonalProfile"
              resize="none"
              :maxlength="limitLength"
              placeholder="例如：主任医师，教授，擅长专业：肺部小结节的鉴别诊断，肺癌 的个体化治疗。"
              v-model="PersonalProfile"
            />
            <span class="limit">
              <span class="tip">{{ PersonalProfile.length }}</span>
              /{{ limitLength }}
            </span>
          </div>
        </div> -->
        <!-- <div class="input-container">
          <label for="Skill">
            <pre class="label need">专业特长:</pre>
          </label>
          <Select
            class="select-container"
            placeholder="请选择专业特长"
            v-model="Skill"
            :list="SkillList"
          />
        </div>
        <div class="input-container">
          <label for="Title">
            <pre class="label need">职&nbsp;&nbsp;&nbsp;称:</pre>
          </label>
          <Select
            class="select-container"
            placeholder="请选择职称"
            v-model="Title"
            :list="TitleList"
          />
        </div>
        <div class="input-container">
          <label for="Title">
            <pre class="label need">附&nbsp;&nbsp;&nbsp;件:</pre>
          </label>
          <div>
            <div class="image-container">
              <div
                class="image-item"
                v-for="(imageUrl, index) in AppendixList"
                :key="index"
              >
                <el-image
                  class="image"
                  :src="imageUrl"
                  :preview-src-list="[imageUrl]"
                />
                <span
                  class="delete-btn"
                  :data-index="index"
                  @click="deleteAppendix"
                ></span>
              </div>
              <button class="file-upload-btn">
                <Upload multiple @change="fileChange" />
              </button>
            </div>
            <span class="file-upload-tip" @click="getUserProfile">
              *可上传执业证、医师证、职称证，只支持上传图片
            </span>
          </div>
        </div> -->
        <slot name="footer" :user="userInfo"></slot>
      </section>
    </div>
  </div>
</template>
<script>
import msgCodeMixin from "@/mixins/codeMixin";
import { fetchSendSms } from "@/api/user";
import { fetchCompleteHospital } from "@/api/hospital";
import { checkParam } from "@/utils";
export default {
  name: "PersonalForget",
  data() {
    return {
      // 手机号
      Phone: "",
      // 短信验证
      MsgCode: "",
      // 登录密码
      Password: "",
      // 确定密码
      PsdConfirm: "",
      // 字数限制
      limitLength: 50,
    };
  },
  mixins: [msgCodeMixin],
  props: {
    action: {
      type: String,
      default: "add",
    },
  },
  computed: {
    userInfo() {
      return {
        phone: this.Phone,
        msgCode: this.MsgCode,
        password: this.Password,
        psdConfirm: this.PsdConfirm,
      };
    },
    hasForget() {
      return this.action === "forget";
    },
    msgCodeContent() {
      const { timeCount } = this;

      return timeCount == 0 ? "获取验证码" : `重新获取(${timeCount})`;
    },
  },
  mounted() {
    
  },
  methods: {
    getCode() {
      this.clickCodeBtn();
    },
    fetchSmsApi() {
      fetchSendSms({
        phone: this.Phone,
      });
    },
    checkSms() {
      const phone = this.Phone.trim();
      const { status, message } = checkParam("phone").execute(phone);

      if (!status) {
        this.$message({ message, type: "error" });
      }

      return status;
    },
    checkSubmitParams(user) {
      let simpleParams = {
        msgCode: "请输入您的短信验证码",
      };
      let strictParams = {
        phone: "",
      };
      if (this.hasForget) {
        Object.assign(simpleParams, {
          password: "请输入您的登录密码",
          psdConfirm: "请再次输入您的登录密码",
        });
      }

      for (let [key, value] of Object.entries(simpleParams)) {
        if (!user[key]) {
          this.$message({ message: value, type: "error" });
          return;
        }

        if (key === "password") {
          if (user.password.length < 6) {
            this.$message({
              message: "密码长度不能低于6位，请补全",
              type: "error",
            });
            return;
          }
          if (user.password !== user.psdConfirm) {
            this.$message({
              message: "密码与确认密码不一致，请重新输入",
              type: "error",
            });
            return;
          }
        }
      }

      for (let key of Object.keys(strictParams)) {
        const validParam = {
          phone: "phone",
          email: "mail",
          IDCardNo: "IDCard",
        };
        const param = validParam[key];
        const value = user[key].trim();
        const { status, message } = checkParam(param).execute(value);

        if (!status) {
          this.$message({ message, type: "error" });
          return;
        }
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
